import React from 'react';
import { Link } from 'react-router-dom';
import './quick-action-card.styles.scss';
import { RenderIf } from '../../RenderIf';
import { Plus } from 'react-feather';

const QuickActionCard = ({
  children,
  description,
  iconBackgroundColor,
  leftActionText = 'ADD',
  rightActionText = 'VIEW',
  addColor = false,
  hideActions = false,
  hideAction1 = false,
  hideAction2 = false,
  transform = false,
  actionEvent1 /* use ev.preventDefault() */,
  actionEvent2,
}) => {
  return (
    <div className={`quick-action-card ${addColor}`}>
      <div className="heading">
        <div className="icon">{children}</div>
        <RenderIf condition={typeof description === 'string'}>
          <h3 className="description text-truncate">{description}</h3>
        </RenderIf>
        <RenderIf condition={typeof description !== 'string'}>
          {description}
        </RenderIf>
      </div>

      <div className={`actions`} hidden={hideActions}>
        {typeof leftActionText === 'string' ? (
          <Link
            to=""
            className="link"
            hidden={hideActions || hideAction1}
            onClick={(e) => {
              e.preventDefault();
              actionEvent1();
            }}
          >
            {leftActionText}
          </Link>
        ) : (
          leftActionText
        )}

        <div
          hidden={hideAction1 || hideAction2 || hideActions}
          className="line"
        ></div>

        {typeof rightActionText === 'string' ? (
          <Link
            hidden={hideAction2 ? hideAction2 : hideActions}
            to=""
            className="link"
            onClick={(e) => {
              e.preventDefault();
              actionEvent2();
            }}
          >
            {rightActionText}
          </Link>
        ) : (
          rightActionText
        )}
      </div>
    </div>
  );
};

export default QuickActionCard;

export function AddCard({ title, onClick, className, style }) {
  return (
    <button
      className={`add-card ${className}`}
      style={{ maxWidth: '300px', ...style }}
      onClick={onClick}
    >
      <Plus size="18" strokeWidth="3" />
      <span className="text-label">{title}</span>
    </button>
  );
}
